(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pourmor-editorial-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pourmor-play')) {
  customElements.define('pourmor-play', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const panels = [...this.querySelectorAll('[data-panel]')];
      const buttons = [...this.querySelectorAll('[data-select]')];
      const control = this.querySelector('.pm-play__motion');
      const media = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.dataset.ready = 'true';
      this.querySelector('.pm-play__controls').hidden = false;
      control.hidden = false;
      const pause = (value) => {
        this.dataset.paused = String(value);
        control.setAttribute('aria-pressed', String(value));
        control.textContent = value ? control.dataset.on : control.dataset.off;
        this.style.setProperty('--rx', '0deg');
        this.style.setProperty('--ry', '0deg');
      };
      pause(media.matches);
      control.addEventListener('click', () => pause(this.dataset.paused !== 'true'), options);
      buttons.forEach(button => button.addEventListener('click', () => {
        const index = button.dataset.select;
        panels.forEach(panel => panel.hidden = panel.dataset.panel !== index);
        buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        this.dataset.scene = index;
      }, options));
      this.addEventListener('pointermove', event => {
        if (media.matches || this.dataset.paused === 'true' || event.pointerType !== 'mouse') return;
        const rect = this.getBoundingClientRect();
        this.style.setProperty('--ry', ((event.clientX-rect.left)/rect.width-.5)*10+'deg');
        this.style.setProperty('--rx', -((event.clientY-rect.top)/rect.height-.5)*6+'deg');
      }, options);
      this.addEventListener('pointerleave', () => {
        this.style.setProperty('--rx','0deg'); this.style.setProperty('--ry','0deg');
      }, options);
      media.addEventListener('change', () => pause(media.matches), options);
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pourmor-motion-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pourmor-motion')) {
  customElements.define('pourmor-motion', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = document.documentElement.hasAttribute('data-pm-paused') || this.reduced.matches || this.dataset.enabled !== 'true';
      this.visible = true;
      this.time = 0;
      this.last = 0;
      this.paths = [...this.querySelectorAll('[data-layer]')];
      this.button = this.querySelector('button');
      this.draw();
      if (this.button) {
        this.button.hidden = false;
        this.updateButton();
        this.button.addEventListener('click', () => {
          this.paused = !this.paused;
          this.updateButton();
          this.start();
        }, { signal });
      }
      document.addEventListener('pourmor:motion', event => {
        this.paused = event.detail.paused || this.reduced.matches || this.dataset.enabled !== 'true';
        this.updateButton();
        this.start();
      }, { signal });
      this.reduced.addEventListener('change', () => {
        this.paused = this.reduced.matches || this.dataset.enabled !== 'true';
        this.updateButton();
        this.start();
      }, { signal });
      this.addEventListener('pointermove', event => {
        if (this.paused || this.reduced.matches || event.pointerType !== 'mouse') return;
        const r = this.getBoundingClientRect();
        this.style.setProperty('--pm-y', ((event.clientX-r.left)/r.width-.5)*1.5+'deg');
        this.style.setProperty('--pm-x', -((event.clientY-r.top)/r.height-.5)+'deg');
        this.style.setProperty('--pm-shine', ((event.clientX-r.left)/r.width-.5)*28+'%');
      }, { signal });
      this.addEventListener('pointerleave', () => this.resetDepth(), { signal });
      document.addEventListener('visibilitychange', () => this.start(), { signal });
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.start();
      });
      this.observer.observe(this);
      this.start();
    }
    resetDepth() {
      this.style.setProperty('--pm-x','0deg');
      this.style.setProperty('--pm-y','0deg');
      this.style.setProperty('--pm-shine','0%');
    }
    updateButton() {
      if (!this.button) return;
      this.button.textContent = this.paused ? this.button.dataset.play : this.button.dataset.pause;
      this.button.setAttribute('aria-pressed', String(this.paused));
      if (this.paused) this.resetDepth();
    }
    draw() {
      const paths = [0,1,2].map(layer => {
        let d = '';
        for (let x=0; x<=1440; x+=24) {
          const y = 69+layer*29+Math.sin(x/290+this.time*(.42+layer*.1)+layer*2)*27+Math.sin(x/160-this.time*.3+layer)*9;
          d += (x ? 'L' : 'M')+x+' '+y.toFixed(2);
        }
        return d;
      });
      this.paths.forEach(path => {
        path.setAttribute('d',paths[Number(path.dataset.layer)]+(path.classList.contains('pm-motion__wave')?'V430H0Z':''));
      });
    }
    start() {
      cancelAnimationFrame(this.frame);
      this.last = 0;
      if (this.paused || !this.visible || document.hidden) return;
      const tick = now => {
        if (!this.last) this.last = now;
        const delta = now-this.last;
        if (delta >= 32) {
          this.time += Math.min(delta,80)/1000;
          this.last = now;
          this.draw();
        }
        this.frame = requestAnimationFrame(tick);
      };
      this.frame = requestAnimationFrame(tick);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.abort?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
